import * as actionTypes from '../actions';
import { addItemInListOfItems, deleteItemByIdInListOfItems, orderZonesByName, updateItemInListOfItems } from "../../helpers";
import { ALL_ZONES_ID } from '../../constants';

const initialState = {
    zones: [],

    currentZone: null,
    
    getZonesLoading: false,
    getZonesError: null,

    addZoneLoading: false,
    addZoneError: null,

    deleteZoneLoading: false,
    deleteZoneError: null,

    updateZoneLoading: false,
    updateZoneError: null,

    zoneItems: [],

    getZoneItemsLoading: false,
    getZoneItemsError: null,

    updateZoneItemsCoordsLoading: false,
    updateZoneItemsCoordsError: null,
};

const zoneReducer = (state = initialState, action) => {
    switch(action.type) {
        // GET ZONES
        case actionTypes.GET_ZONES_REQUEST:
            return {
                ...state,
                getZonesLoading: action.loading,
            };
        case actionTypes.GET_ZONES_SUCCESS:
            return {
                ...state,
                getZonesLoading: action.loading,
                getZonesError: null,
                zones: orderZonesByName(action.zones),
                currentZone: (!state.currentZone)? ALL_ZONES_ID :state.currentZone,
            };
        case actionTypes.GET_ZONES_ERROR:
            return {
                ...state,
                getZonesLoading: action.loading,
                getZonesError: action.error,
            };

        // ADD ZONE
        case actionTypes.ADD_ZONE_REQUEST:
            return {
                ...state,
                addZoneLoading: action.loading,
            };
        case actionTypes.ADD_ZONE_SUCCESS:
            return {
                ...state,
                addZoneLoading: action.loading,
                addZoneError: null,
                zones: orderZonesByName(addItemInListOfItems(state.zones, action.zone)),
            };
        case actionTypes.ADD_ZONE_ERROR:
            return {
                ...state,
                addZoneLoading: action.loading,
                addZoneError: action.error,
            };
        
        // DELETE ZONE
        case actionTypes.DELETE_ZONE_REQUEST:
            return {
                ...state,
                deleteZoneLoading: action.loading,
            };
        case actionTypes.DELETE_ZONE_SUCCESS:
            return {
                ...state,
                deleteZoneLoading: action.loading,
                deleteZoneError: null,
                zones: orderZonesByName(deleteItemByIdInListOfItems(state.zones, action.zoneId)),
            };
        case actionTypes.DELETE_ZONE_ERROR:
            return {
                ...state,
                deleteZoneLoading: action.loading,
                deleteZoneError: action.error,
            };
        
        // UPDATE ZONE
        case actionTypes.UPDATE_ZONE_REQUEST:
            return {
                ...state,
                updateZoneLoading: action.loading,
            };
        case actionTypes.UPDATE_ZONE_SUCCESS:
            return {
                ...state,
                updateZoneLoading: action.loading,
                updateZoneError: null,
                zones: orderZonesByName(updateItemInListOfItems(state.zones, action.zone)),
            };
        case actionTypes.UPDATE_ZONE_ERROR:
            return {
                ...state,
                updateZoneLoading: action.loading,
                updateZoneError: action.error,
            };

        // SET CURRENT ZONE
        case actionTypes.SET_CURRENT_ZONE:
            return {
                ...state,
                currentZone: action.zoneId,
            };
        
        // GET ZONE ITEMS
        case actionTypes.GET_ZONE_ITEMS_REQUEST:
            return {
                ...state,
                getZoneItemsLoading: true,
            };
        case actionTypes.GET_ZONE_ITEMS_ERROR:
            return {
                ...state,
                getZoneItemsLoading: false,
                getZoneItemsError: action.error,
            };
        case actionTypes.GET_ZONE_ITEMS_SUCCESS:
            return {
                ...state,
                getZoneItemsLoading: false,
                getZoneItemsError: null,
                zoneItems: action.zoneItems,
            }

        // UPDATE ZONE ITEM COORDS
        case actionTypes.UPDATE_ZONE_ITEMS_COORDS_REQUEST:
            return {
                ...state,
                updateZoneItemsCoordsLoading: true,
            };
        
        case actionTypes.UPDATE_ZONE_ITEMS_COORDS_ERROR:
            return {
                ...state,
                updateZoneItemsCoordsLoading: false,
                updateZoneItemsCoordsError: action.error,
            };
        
        case actionTypes.UPDATE_ZONE_ITEMS_COORDS_SUCCESS:
            return {
                ...state,
                updateZoneItemsCoordsLoading: false,
                updateZoneItemsCoordsError: null,
                zoneItems: updateItemInListOfItems(state.zoneItems, action.zoneItem),
            };
        
        case actionTypes.SET_ZONES:
            return {
                ...state,
                zones: [...action.zones],
            };

        // DEFAULT
        default:
            return state;
    }
};

export default zoneReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/zones.js